/*=========================================================================================
  File Name: moduleUserGetters.js
  Description: User Module Getters
  ----------------------------------------------------------------------------------------
==========================================================================================*/


export default {
  getUser: state =>(login_id) => state.users.find(user => user.login_id === login_id)
}
